import { useState, useRef, useEffect } from 'react'
import { WorkerMessage, HordeStatus } from '@shared-types'
import { NotificationManager } from '@client/utility'

export function useImageWorker() {
  const [images, setImages] = useState<string[]>([])
  const [status, setStatus] = useState<HordeStatus | null>(null)
  const [isLoading, setIsLoading] = useState(false)
  const [lastCompletedImage, setLastCompletedImage] = useState<string | null>(null)
  const workerRef = useRef<Worker | null>(null)

  useEffect(() => {
    if (!workerRef.current) {
      workerRef.current = new Worker('/worker/imageWorker.js')

      workerRef.current.onmessage = (e: MessageEvent<WorkerMessage>) => {
        const msg = e.data

        if (msg.type === 'status') setStatus(msg.status || null)

        if (msg.type === 'done') {
          setStatus(msg.status || null)

          if (msg.generation?.modelDone && msg.generation.img) {
            setImages(prev => [...prev, msg.generation.img])
            setLastCompletedImage(msg.generation.img)

            if (document.visibilityState !== 'visible') {
              NotificationManager.fire({
                title: 'Image Ready!',
                body: 'Your AI-generated image has finished.',
                icon: msg.generation.img,
                vibrateIfPossible: true,
              })
            }
          }

          setIsLoading(false)
        }

        if (msg.type === 'error') {
          console.error(msg.error)
          setIsLoading(false)
        }
      }
    }

    return () => {
      workerRef.current?.postMessage({ type: 'stop' })
    }
  }, [])

  const submit = (payload: any) => {
    if (!payload) return
    setIsLoading(true)
    setStatus(null)
    workerRef.current?.postMessage(payload)
  }

  return { images, status, isLoading, submit, lastCompletedImage }
}
